import CustomerList from './CustomerList.jsx'

export default CustomerList
